import { Box } from "@mui/system";
import React from "react";
import { Background } from "../../Components";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { CONNECTION_STEP_CONTENT } from "../../utils/constants";
import "./ConnectionSteps.scss";
function ConnectionSteps() {
  return (
    <Background backButtonUrl={ROUTE_LANDING_PAGE}>
      <Box className="connections-steps-container">
        <Box className="steps-header">{CONNECTION_STEP_CONTENT.header}</Box>
        {CONNECTION_STEP_CONTENT.steps.map((step, index) => (
          <Box className="steps-main-container" key={index}>
            <Box className="steps-title-box">
              <Box className="message-number">
                <Box>{+index + 1}</Box>
              </Box>
              <Box> {step.title}</Box>
            </Box>
            <Box>{step.icon}</Box>
          </Box>
        ))}
      </Box>
    </Background>
  );
}

export default ConnectionSteps;
